import React from 'react'
import { connect } from 'react-redux'

const WhatsappConfigEditForm = ({fields2, setFields2, error, setError, addField, removeField}) => {
    return (
        <>
            <div className='form-group row mb-4 d-flex justify-content-between'>
                <h5 className="kt-subheader__title">Configuration Whatsapp</h5>
                <button className='btn btn-sm btn-success' onClick={addField}> <i className='la la-plus m-0 p-0'></i> Nouveau champ </button>
            </div>

            {fields2.map((field, index) => (

                <div key={index} className="form-group row">
                    
                    <div className="col-lg-4 col-md-4 col-sm-6">
                        <input
                            type="text"
                            className="form-control"
                            value={field.key}
                            onChange={(e) => {
                                setFields2(
                                    fields2.map((f, i) =>
                                        i === index ? { ...f, key: e.target.value } : f
                                    )
                                );
                            }}
                            placeholder="Clé"
                        />
                        {
                            error.fields2 && error.fields2[index] && error.fields2[index].key && (
                                <span className='text-danger'>{error.fields2[index].key}</span>
                            )
                        }
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6">
                        <input
                            type="text"
                            className="form-control"
                            value={field.value}
                            onChange={(e) => {
                                setFields2(
                                    fields2.map((f, i) =>
                                        i === index ? { ...f, value: e.target.value } : f
                                    )
                                );
                            }}
                            placeholder="Valeur"
                        />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <button className='btn btn-sm btn-danger' onClick={() => removeField(index)}> <i className='la la-trash m-0 p-0'></i> </button>
                    </div> 
                    
                </div>

            ))}

            <div className="form-group row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="kt-separator kt-separator--dashed"></div>
                </div>
            </div>

            {error.whatsappError && (
                <div className="text-danger">
                    {error.whatsappError}
                </div>
            )}

        </>
    )
}

export default WhatsappConfigEditForm